import React from 'react';
import PropTypes from 'prop-types';
import { valueForKeyPath as v } from '../../utils.jsx';
import SectionForm from './components/SectionForm.jsx';
import ArticleList from './components/ArticleList.jsx';
import ArticleForm from './components/ArticleForm.jsx';
import StaticTextForm from './components/StaticTextForm.jsx';
import StaticContent from './components/StaticContent.jsx';
// import ArticlePreviewAndComments from './components/ArticlePreviewAndComments.jsx';
import MenuTree from './components/MenuTree.jsx';

import MediaBrowserService from './components/mediaBrowser/MediaBrowserService.jsx';

import ArticleWidgetYoutube from './components/ArticleWidgets/ArticleYoutubeWidget.jsx';
import ArticleWidgetTvkosice from './components/ArticleWidgets/ArticleTvkosiceWidget.jsx';
import ArticleWidgetFormattedText from './components/ArticleWidgets/ArticleWidgetFormattedText.jsx';
import ArticleWidgetTable from './components/ArticleWidgets/ArticleWidgetTable.jsx';
import ImageadWidget from './components/ArticleWidgets/ArticleImageadWidget.jsx';
import ArticleWidgetText from './components/ArticleWidgets/ArticleWidgetText.jsx';
import ArticleWidgetPhoto from './components/ArticleWidgets/ArticleWidgetPhoto.jsx';
import ArticleWidgetPhotogallery from './components/ArticleWidgets/ArticleWidgetPhotogallery.jsx';
import ArticleWidgetScreenimage from './components/ArticleWidgets/ArticleWidgetScreenimage.jsx';
import ArticleWidgetAudio from './components/ArticleWidgets/ArticleAudioWidget.jsx';
import ArticleFBVideoWidget from './components/ArticleWidgets/ArticleFBVideoWidget.jsx';
import ArticleInstagramPostWidget from './components/ArticleWidgets/ArticleInstagramPostWidget.jsx';
import ArticleTwitterPostWidget from './components/ArticleWidgets/ArticleTwitterPostWidget.jsx';
import ArticleSoundcloudWidget from './components/ArticleWidgets/ArticleSoundcloudWidget';
import VideoWidget from './components/ArticleWidgets/ArticleVideoWidget.jsx';
import ImageEditor from './components/ImageEditor.jsx';

const cx = require('classnames');

const Pager = props => {
  if (!props.total) {
    return null;
  }
  const start = 1;
  const end = Math.ceil(props.total / props.limit);
  if (end === 1) {
    return null;
  }
  const current = Math.ceil(props.offset / props.limit);
  return (
    <div className="btn-group">
      {Array(end)
        .fill()
        .map((_, i) => {
          const offset = i * props.limit;
          if (
            i === 0 ||
            i === end - 1 ||
            (i > current - 5 && i < current + 5)
          ) {
            return (
              <button
                key={offset}
                className={cx('btn btn-sm btn-default', {
                  'btn-primary': current === i,
                })}
                onClick={() => {
                  props.onChange(offset);
                }}
              >
                {i + 1}
              </button>
            );
          }
          if (i === current - 5) {
            return (
              <button key={offset} className="btn btn-sm btn-link" disabled>
                ...
              </button>
            );
          }
          if (i === current + 5) {
            return (
              <button key={offset} className="btn btn-sm btn-link" disabled>
                ...
              </button>
            );
          }
          return null;
        })}
    </div>
  );
};

const ContentManagerModalDialog = props => {
  return (
    <div>
      <div className="modal fade in" style={{ display: 'block' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={props.onClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">{props.title}</h4>
            </div>
            <div className="modal-body">{props.children}</div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

class ContentManagerOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      createNewSectionDialog: false,
      createNewSectionLoading: false,
      staticTextsDialog: false,
      staticCid: '',
      staticName: '',
      selectedSection: null,
      sectionToEdit: null,
      sectionDropTreeDialog: {
        show: false,
        section: {},
      },
      selectedArticles: [],
    };

    this.createNewSection = this.createNewSection.bind(this);
    this.didCreateNewSection = this.didCreateNewSection.bind(this);
    this.menuItemToggleOpen = this.menuItemToggleOpen.bind(this);
    this.openMediaBrowser = this.openMediaBrowser.bind(this);
    this.createNewText = this.createNewText.bind(this);
    this.onStaticTextDelete = this.onStaticTextDelete.bind(this);
    this.onStaticTextCreate = this.onStaticTextCreate.bind(this);
    this.closeTextModal = this.closeTextModal.bind(this);
    this.onEditStaticContent = this.onEditStaticContent.bind(this);
    this.createSubNode = this.createSubNode.bind(this);
    this.editSectionTreeButtonClicked = this.editSectionTreeButtonClicked.bind(
      this,
    );
    this.moveSectionTreeButtonClicked = this.moveSectionTreeButtonClicked.bind(
      this,
    );
    this.dropSection = this.dropSection.bind(this);
    this.onTreeMenuDropSelectItem = this.onTreeMenuDropSelectItem.bind(this);
    this.findSection = this.findSection.bind(this);
    this.closeSectionModal = this.closeSectionModal.bind(this);
    this.onSectionDropRootSelect = this.onSectionDropRootSelect.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectArticle = this.handleSelectArticle.bind(this);
    this.handleBulkDelete = this.handleBulkDelete.bind(this);
  }

  handleChangeSearch(e) {
    const {
      target: { value },
    } = e;
    this.props.onChangeQueryParams(value);
  }

  handleSelectAll(checked) {
    if (checked) {
      const allArticleIds = this.props.articles.map(article => article._id);
      this.setState({ selectedArticles: allArticleIds });
    } else {
      this.setState({ selectedArticles: [] });
    }
  }

  handleSelectArticle(articleId, checked) {
    if (checked) {
      this.setState(prevState => ({
        selectedArticles: [...prevState.selectedArticles, articleId]
      }));
    } else {
      this.setState(prevState => ({
        selectedArticles: prevState.selectedArticles.filter(id => id !== articleId)
      }));
    }
  }

  handleBulkDelete() {
    if (this.state.selectedArticles.length === 0) {
      alert('Nie sú vybrané žiadne články');
      return;
    }

    const confirmMessage = `Naozaj chcete odstrániť ${this.state.selectedArticles.length} článkov?`;
    if (!window.confirm(confirmMessage)) {
      return;
    }

    this.props.onBulkDeleteArticles(this.state.selectedArticles)
      .then(() => {
        this.setState({ selectedArticles: [] });
      })
      .catch(error => {
        alert('Pri mazaní článkov došlo k chybe');
      });
  }

  createNewSection() {
    this.setState({
      createNewSectionDialog: !this.state.createNewSectionDialog,
      selectedSection: null,
    });
  }

  didCreateNewSection(section) {
    this.setState({ createNewSectionLoading: true });
    if (this.state.selectedSection) {
      section['parent'] = this.state.selectedSection;
    }
    this.props
      .didCreateNewSection(section)
      .then(response => {
        // schovame formular
        this.setState({
          createNewSectionDialog: false,
          createNewSectionLoading: false,
          selectedSection: null,
        });
        this.props.reloadSections();
      })
      .catch(error => {
        if (error.response.status === 409) {
          alert('Rubrika so zadaným URL alebo IDENTIFIKÁTOROM už existuje');
        } else {
          alert(error.details.description);
        }
        this.setState({ createNewSectionLoading: false });
      });
  }

  menuItemToggleOpen(item) {
    this.props.reloadSections(item._id);
  }

  openMediaBrowser() {
    var onFileSelect = function() {
      return false;
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  }

  createNewText() {
    this.setState({ staticTextsDialog: true });
  }

  onStaticTextDelete(textID) {
    var _this = this;
    var onSuccess = function() {
      _this.closeTextModal();
      _this.props.reloadStaticTexts();
    };

    var onError = function() {
      alert('Pri odstraňovaní statického textu došlo k chybe');
    };

    this.props.deleteStaticText(textID).then(onSuccess, onError);
  }

  onStaticTextCreate(obj) {
    var _this = this;
    var onSuccess = function() {
      _this.closeTextModal();
      _this.props.reloadStaticTexts();
    };

    var onError = function() {
      alert('Pri ukladaní statického textu došlo k chybe');
    };

    if (this.state.staticCid !== '') {
      this.props.updateStaticText(obj).then(onSuccess, onError);
    } else {
      this.props.createStaticText(obj).then(onSuccess, onError);
    }
  }

  closeTextModal() {
    this.setState({
      staticTextsDialog: false,
      staticCid: '',
      staticName: '',
    });
  }

  onEditStaticContent(cid, name) {
    this.setState({
      staticTextsDialog: true,
      staticCid: cid,
      staticName: name,
    });
  }

  createSubNode(parentId) {
    this.setState({
      createNewSectionDialog: true,
      selectedSection: parentId,
    });
  }

  editSectionTreeButtonClicked(sectionId) {
    let section;
    section = this.findSection(sectionId, this.props.sections);
    this.setState({ sectionToEdit: section }, this.props.onSectionEditClick());
  }

  findSection(sectionId, sections) {
    for (let i = 0; i < sections.length; i++) {
      if (sections[i]._id === sectionId) {
        return sections[i];
      } else {
        if (sections[i].sections) {
          let section = this.findSection(sectionId, sections[i].sections);
          if (section) {
            return section;
          }
        }
      }
    }
  }

  moveSectionTreeButtonClicked(sectionId) {
    let section;
    section = this.findSection(sectionId, this.props.sections);

    this.setState({ sectionDropTreeDialog: { section: {} } }, function() {
      this.setState({
        sectionDropTreeDialog: { show: true, section: section },
      });
    });
  }

  getSectionsExceptCurrent(sectionId) {
    let sections = [];
    this.props.sections.forEach(s => {
      if (s._id !== sectionId) {
        sections.push(s);
      }
    });
    return sections;
  }

  dropSection() {
    this.setState({ sectionDropTreeDialog: { section: {} } }, function() {
      this.setState({ sectionDropTreeDialog: { show: false, section: {} } });
    });
  }

  onTreeMenuDropSelectItem(section) {
    this.setState({ createNewSectionLoading: true });
    if (this.state.sectionDropTreeDialog.section) {
      this.state.sectionDropTreeDialog.section['parent'] = section._id;
    }

    this.props
      .didCreateNewSection(this.state.sectionDropTreeDialog.section)
      .then(response => {
        // schovame formular
        this.setState({ sectionDropTreeDialog: { section: {} } }, function() {
          this.setState({
            sectionDropTreeDialog: { show: false, section: {} },
          });
        });
        this.props.reloadSections();
      })
      .catch(error => {
        alert(error.details.description);
        this.setState({ createNewSectionLoading: false });
      });
  }

  onSectionDropRootSelect() {
    this.onTreeMenuDropSelectItem({ _id: null });
  }

  closeSectionModal() {
    this.setState({ sectionToEdit: null });
    this.props.closeSectionModal();
  }

  render() {
    let createOrEditSection;
    let staticTexts;
    let sectionDrop;

    if (this.state.createNewSectionDialog) {
      createOrEditSection = (
        <ContentManagerModalDialog
          title="Nová sekcia"
          onClose={this.createNewSection}
        >
          <SectionForm
            onSave={this.didCreateNewSection}
            loading={this.state.createNewSectionLoading}
          />
        </ContentManagerModalDialog>
      );
    }

    if (this.props.editSectionDialog) {
      let section_to_edit = this.props.currentSection;
      if (this.state.sectionToEdit) {
        section_to_edit = this.state.sectionToEdit;
      }
      createOrEditSection = (
        <ContentManagerModalDialog
          title="Upraviť rubriku"
          onClose={this.closeSectionModal}
        >
          <SectionForm
            section={section_to_edit}
            onSave={this.props.didUpdateSection}
            onDelete={this.props.didDeleteSection}
            loading={this.state.createNewSectionLoading}
          />
        </ContentManagerModalDialog>
      );
    }

    if (
      this.state.sectionDropTreeDialog.show &&
      this.state.sectionDropTreeDialog.section
    ) {
      let title =
        'Zaradenie ' +
        this.state.sectionDropTreeDialog.section.name +
        ' do inej rubriky';
      sectionDrop = (
        <ContentManagerModalDialog title={title} onClose={this.dropSection}>
          <a
            href="javascript:void(0);"
            onClick={this.onSectionDropRootSelect}
            data-id="0"
          >
            <strong>Koreň</strong>
          </a>
          <MenuTree
            showButtons={false}
            currentSection={this.props.currentSection}
            onItemClick={this.onTreeMenuDropSelectItem}
            tree={this.getSectionsExceptCurrent(
              this.state.sectionDropTreeDialog.section._id,
            )}
            onItemToggleOpen={this.menuItemToggleOpen}
            createSubNode={this.createSubNode}
            editSection={this.editSectionTreeButtonClicked}
            moveSection={this.moveSectionTreeButtonClicked}
          />
        </ContentManagerModalDialog>
      );
    }

    if (this.state.staticTextsDialog) {
      createOrEditSection = (
        <ContentManagerModalDialog
          title="Statický text"
          onClose={this.closeTextModal}
        >
          <StaticTextForm
            name={this.state.staticName}
            cid={this.state.staticCid}
            isNew={!this.state.staticCid}
            onSubmit={this.onStaticTextCreate}
            onDelete={this.onStaticTextDelete}
          />
        </ContentManagerModalDialog>
      );
    }

    staticTexts = this.props.static_content.map(element => {
      return (
        <StaticContent
          key={element.cid}
          onEdit={this.onEditStaticContent}
          onStaticTextClick={this.props.onStaticTextClick}
          name={element.name}
          cid={element.cid}
        />
      );
    });
    return (
      <div className="row">
        <div className="col-md-3">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <strong> Media Browser </strong>
                </div>
                <div className="panel-body">
                  <button
                    className="btn btn-primary btn-block btn-sm"
                    onClick={this.openMediaBrowser}
                  >
                    Otvoriť media browser
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <strong>Editor obrázkov</strong>
                </div>
                <div className="panel-body">
                  <button
                    className="btn btn-primary btn-block btn-sm"
                    onClick={this.props.openImageEditor}
                  >
                    Otvoriť editor obrázkov
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <strong>Menu</strong>
                </div>
                <div className="panel-body">
                  <MenuTree
                    showButtons={true}
                    currentSection={this.props.currentSection}
                    onItemClick={this.props.onTreeMenuItemClick}
                    tree={this.props.sections}
                    onItemToggleOpen={this.menuItemToggleOpen}
                    createSubNode={this.createSubNode}
                    editSection={this.editSectionTreeButtonClicked}
                    moveSection={this.moveSectionTreeButtonClicked}
                  />
                  <button
                    className="btn btn-primary btn-block btn-sm"
                    onClick={this.createNewSection}
                  >
                    <i className="fa fa-plus" /> Vytvoriť menu
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <strong>Texty</strong>
                </div>
                <div className="panel-body">
                  <ul className="tree">{staticTexts}</ul>
                  <button
                    className="btn btn-primary btn-block btn-sm"
                    onClick={this.createNewText}
                  >
                    Pridať nový text
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-9">
          <div id="article-list" className="panel panel-default">
            <div className="panel-heading clearfix">
              <strong>Zoznam článkov</strong>
            </div>

            <div className="panel-body">
              <div className="search-wrapper">
                <div className="text-left search-input-wrapper">
                  <input
                    placeholder="Hľadať článok"
                    className="form-control"
                    onChange={this.handleChangeSearch}
                  />
                </div>
                <div className="text-right pager">
                  <Pager
                    {...this.props.articlesPager}
                    onChange={this.pagerDidChange.bind(this)}
                  />
                </div>
              </div>

              {this.state.selectedArticles.length > 0 && (
                <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={this.handleBulkDelete}
                  >
                    <i className="fa fa-trash" /> Odstrániť vybrané ({this.state.selectedArticles.length})
                  </button>
                </div>
              )}

              <ArticleList
                articles={this.props.articles}
                offset={this.props.articlesPager.offset}
                didSelectArticle={this.props.didSelectArticleForEdit}
                actions={[
                  {
                    actionName: '',
                    icon: 'pencil',
                    didFireAction: this.props.didSelectArticleForEdit,
                  },
                ]}
                contentspace_info={this.props.contentspace_info}
                showCheckboxes={true}
                selectedArticles={this.state.selectedArticles}
                onSelectAll={this.handleSelectAll}
                onSelectArticle={this.handleSelectArticle}
              />
              <div className="text-right">
                <Pager
                  {...this.props.articlesPager}
                  onChange={this.pagerDidChange.bind(this)}
                />
              </div>
              {this.props.articlesIsLoading && (
                <div
                  style={{
                    background: 'rgba(255,255,255,0.7)',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                  }}
                >
                  <div className="loader" />
                </div>
              )}
            </div>
          </div>
        </div>
        {createOrEditSection}
        {sectionDrop}
      </div>
    );
  }

  pagerDidChange(offset) {
    this.props.pagerDidChange(offset);
  }
}

class ContentManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateNewArticle: false,
      articleIsSaving: false,
      editArticleId: null,
      previewArticleId: null,
      previewArticle: null,
      currentSection: null,
      previewStaticText: false,
      staticTextCid: null,
      editSectionContentId: null,
      editSectionDialog: false,
      imageEditor: false,
    };

    this.cancelArticleForm = this.cancelArticleForm.bind(this);
    this.showCreateNewArticle = this.showCreateNewArticle.bind(this);
    this.articleDidSave = this.articleDidSave.bind(this);
    this.articleDidPreview = this.articleDidPreview.bind(this);
    this.articleDidRemove = this.articleDidRemove.bind(this);
    this.didSelectArticleForEdit = this.didSelectArticleForEdit.bind(this);
    this.didSelectArticleForPreviewAndComments = this.didSelectArticleForPreviewAndComments.bind(
      this,
    );
    this.previewArtcileDidFinishLoading = this.previewArtcileDidFinishLoading.bind(
      this,
    );
    this.onTreeMenuItemClick = this.onTreeMenuItemClick.bind(this);
    this.cancelSectionSelection = this.cancelSectionSelection.bind(this);
    this.onSectionEditClick = this.onSectionEditClick.bind(this);
    this.closeSectionModal = this.closeSectionModal.bind(this);
    this.didDeleteSection = this.didDeleteSection.bind(this);
    this.didUpdateSection = this.didUpdateSection.bind(this);
    this.onStaticTextClick = this.onStaticTextClick.bind(this);
    this.onStaticTextCancel = this.onStaticTextCancel.bind(this);
    this.onUpdateStaticTextContent = this.onUpdateStaticTextContent.bind(this);
    this.onDeleteStaticTextContent = this.onDeleteStaticTextContent.bind(this);
    this.onSectionContentClose = this.onSectionContentClose.bind(this);
    this.onSectionContentClick = this.onSectionContentClick.bind(this);
    this.onUpdateSectionContent = this.onUpdateSectionContent.bind(this);
    this.onDeleteSectionContent = this.onDeleteSectionContent.bind(this);
    this.openImageEditor = this.openImageEditor.bind(this);
    this.handleImageEditorBackButtonClick = this.handleImageEditorBackButtonClick.bind(this);
  }

  cancelArticleForm() {
    this.setState({
      showCreateNewArticle: false,
      editArticleId: null,
      previewArticleId: null,
      previewArticle: null,
      editSectionContentId: null,
      previewStaticText: false,
    });
  }

  articleDidSave(article, articleId = null) {
    this.setState({ articleIsSaving: true });
    let sectionId = null;
    if (this.state.currentSection) {
      article.sectionid = this.state.currentSection._id;
      sectionId = this.state.currentSection._id;
    }
    this.props
      .saveArticle(article, articleId)
      .then(response => {
        // schovame formular
        this.cancelArticleForm();
        this.props.reloadArticles(sectionId);
        this.setState({ articleIsSaving: false });
      })
      .catch(error => {
        if (error.response.status === 409) {
          alert('Článok so zadaným URL už existuje');
        } else {
          alert(error.details.description);
        }
        this.setState({ articleIsSaving: false });
      });
  }

  articleDidPreview(article, articleId = null) {
    this.setState({ articleIsSaving: true });
    let sectionId = null;
    if (this.state.currentSection) {
      article.sectionid = this.state.currentSection._id;
    }
    // Ulozime preview do API a redirectneme na preview
    this.props
      .saveArticlePreview(article)
      .then(response => {
        const previewUrl =
          this.props.previewUrl + '?preview_id=' + response.preview_id;
        this.gotoPreview(previewUrl);
        this.setState({ articleIsSaving: false });
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  gotoPreview(previewUrl) {
    let w = window.open(previewUrl);
  }

  articleDidRemove(articleId = null) {
    this.cancelArticleForm();
    this.props
      .removeArticle(articleId)
      .then(response => {
        // vsetko OK
      })
      .catch(error => {
        alert(error.details.description);
        this.props.reloadArticles();
      });
  }

  didSelectArticleForEdit(articleId) {
    this.setState({ editArticleId: articleId });
  }

  showCreateNewArticle() {
    this.setState({
      showCreateNewArticle: true,
      editArticleId: null,
      previewArticleId: null,
      previewArticle: null,
    });
  }

  didSelectArticleForPreviewAndComments(articleId) {
    this.setState({ previewArticleId: articleId, previewArticle: null });
  }

  previewArtcileDidFinishLoading(article) {
    this.setState({ previewArticleId: article._id, previewArticle: article });
  }

  onTreeMenuItemClick(item) {
    this.setState({
      currentSection: item,
    });
    this.props.onTreeMenuItemClick(item);
  }

  cancelSectionSelection() {
    this.props.reloadArticles();
    this.setState({
      currentSection: null,
    });
  }

  onSectionEditClick() {
    this.setState({
      editSectionDialog: true,
    });
  }

  closeSectionModal() {
    this.setState({
      editSectionDialog: false,
    });
  }

  didUpdateSection(section) {
    this.props
      .didCreateNewSection(section)
      .then(response => {
        this.closeSectionModal();
        this.props.reloadSections();
      })
      .catch(error => {
        if (error.response.status === 409) {
          alert('Rubrika so zadaným URL alebo IDENTIFIKÁTOROM už existuje');
        } else {
          alert(error.details.description);
        }
      });
  }

  didDeleteSection(section) {
    this.props
      .didDeleteSection(section)
      .then(response => {
        this.closeSectionModal();
        this.props.reloadSections();
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  onStaticTextClick(cid) {
    this.setState({ previewStaticText: true, staticTextCid: cid });
  }

  onStaticTextCancel() {
    this.setState({
      previewStaticText: false,
      staticTextCid: null,
    });
  }

  onUpdateStaticTextContent(data, cid) {
    this.props
      .onUpdateStaticTextContent(data, cid)
      .then(response => {
        this.onStaticTextCancel();
        this.props.reloadArticles();
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  onDeleteStaticTextContent(cid) {
    this.props
      .onDeleteStaticTextContent(cid)
      .then(response => {
        this.onStaticTextCancel();
        this.props.reloadArticles();
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  onSectionContentClick() {
    var sectionId = null;
    if (this.state.currentSection !== null) {
      sectionId = this.state.currentSection._id;
    }

    this.setState({
      editSectionContentId: sectionId,
    });
  }

  onSectionContentClose() {
    this.setState({
      editSectionContentId: null,
    });
  }

  onUpdateSectionContent(data, sectionId) {
    this.props
      .onUpdateSectionContent(data, sectionId)
      .then(response => {
        this.onSectionContentClose();
        this.props.reloadArticles(sectionId);
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  onDeleteSectionContent(sectionId) {
    this.props
      .onDeleteSectionContent(sectionId)
      .then(response => {
        this.onSectionContentClose();
        this.props.reloadArticles(sectionId);
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  openImageEditor() {
    this.setState({
      imageEditor: true,
    })
  }

  handleImageEditorBackButtonClick() {
    this.setState({
      imageEditor: false,
    })
  }

  render() {
    let content = null;
    const leftContextbuttons = [];
    const rightContextButtons = [];
    let backbutton;
    let contextText = 'Správa obsahu';

    if (this.state.showCreateNewArticle || this.state.editArticleId) {
      content = (
        <ArticleForm
          contentspace_info={this.props.contentspace_info}
          articleId={this.state.editArticleId}
          articleDidSave={this.articleDidSave}
          articleDidPreview={this.articleDidPreview}
          articleDidRemove={this.articleDidRemove}
          articleIsSaving={this.state.articleIsSaving}
          loadArticle={this.props.loadArticle}
          articleDidCancel={this.cancelArticleForm}
          widgets={this.props.availableWidgets}
          mediaManager={this.props.mediaManager}
          loadSection={this.props.loadSection}
          sections={this.props.sections}
          reloadSections={this.props.reloadSections}
          defaultAuthorName={this.props.defaultAuthorName}
        />
      );
      backbutton = (
        <a
          className="btn btn-default"
          onClick={this.cancelArticleForm}
          key="back"
        >
          <span className="fa fa-arrow-left" />
        </a>
      );
      contextText = this.state.editArticleId ? 'Upraviť článok' : 'Nový článok';
    } else if (this.state.previewStaticText) {
      content = (
        <ArticleForm
          contentspace_info={this.props.contentspace_info}
          articleDidCancel={this.onStaticTextCancel}
          staticTextCid={this.state.staticTextCid}
          loadArticleForStaticText={this.props.onStaticTextClick}
          widgets={this.props.availableWidgets}
          mediaManager={this.props.mediaManager}
          onUpdateStaticTextContent={this.onUpdateStaticTextContent}
          onDeleteStaticTextContent={this.onDeleteStaticTextContent}
        />
      );

      backbutton = (
        <a
          className="btn btn-default"
          onClick={this.onStaticTextCancel}
          key="back"
        >
          <span className="fa fa-arrow-left" />
        </a>
      );
      contextText = 'Statický text';
    } else if (this.state.editSectionContentId) {
      content = (
        <ArticleForm
          contentspace_info={this.props.contentspace_info}
          sectionId={this.state.editSectionContentId}
          loadSectionContent={this.props.loadSectionContent}
          widgets={this.props.availableWidgets}
          mediaManager={this.props.mediaManager}
          onUpdateSectionContent={this.onUpdateSectionContent}
          onDeleteSectionContent={this.onDeleteSectionContent}
        />
      );
      backbutton = (
        <a
          className="btn btn-default"
          onClick={this.onSectionContentClose}
          key="back"
        >
          <span className="fa fa-arrow-left" />
        </a>
      );
      contextText = 'Popisný text rubriky';
    } else if(this.state.imageEditor) {
      backbutton = (
        <a
          className="btn btn-default"
          onClick={this.handleImageEditorBackButtonClick}
          key="back"
        >
          <span className="fa fa-arrow-left" />
        </a>
      );
      content = (<ImageEditor mediaManager={this.props.mediaManager}/>)
      contextText = 'Editor obrázkov';
    } else {
      if (this.state.currentSection) {
        backbutton = (
          <a
            className="btn btn-default"
            onClick={this.cancelSectionSelection}
            key="back"
          >
            <span className="fa fa-arrow-left" />
          </a>
        );

        {
          /*rightContextButtons.push(<button  key="button-edit-section"
                                                  onClick={this.onSectionEditClick}
                                                  className="btn btn-default"
                                                  type="button"
                                                  title="Upraviť rubriku">
                    <span className="fa fa-pencil" />
                </button>);*/
        }
        rightContextButtons.push(
          <button
            key="button-create-subsection"
            onClick={this.onSectionContentClick}
            className="btn btn-default"
            type="button"
            title="Popisný text rubriky"
          >
            <span className="fa fa-font" />
          </button>,
        );

        contextText = this.state.currentSection.name;
      }
      rightContextButtons.push(
        <button
          key="button-create-article"
          onClick={this.showCreateNewArticle}
          className="btn btn-default"
          type="button"
          title="Pridať článok do rubliky"
        >
          <span className="fa fa-plus" />
        </button>,
      );
      content = (
        <ContentManagerOverview
          onChangeQueryParams={this.props.onChangeQueryParams}
          articles={this.props.articles}
          articlesIsLoading={this.props.articlesIsLoading}
          articlesPager={this.props.articlesPager}
          pagerDidChange={this.props.pagerDidChange}
          sections={this.props.sections}
          static_content={this.props.static_texts}
          contentspace_info={this.props.contentspace_info}
          didCreateNewSection={this.props.didCreateNewSection}
          reloadSections={this.props.reloadSections}
          didSelectArticleForEdit={this.didSelectArticleForEdit}
          openImageEditor={this.openImageEditor}
          didSelectArticleForPreviewAndComments={
            this.didSelectArticleForPreviewAndComments
          }
          mediaManager={this.props.mediaManager}
          onTreeMenuItemClick={this.onTreeMenuItemClick}
          currentSection={this.state.currentSection}
          editSectionDialog={this.state.editSectionDialog}
          closeSectionModal={this.closeSectionModal}
          didUpdateSection={this.didUpdateSection}
          didDeleteSection={this.didDeleteSection}
          createStaticText={this.props.createStaticText}
          updateStaticText={this.props.updateStaticText}
          deleteStaticText={this.props.deleteStaticText}
          reloadStaticTexts={this.props.reloadStaticTexts}
          onStaticTextClick={this.onStaticTextClick}
          onSectionEditClick={this.onSectionEditClick}
          onBulkDeleteArticles={this.props.bulkDeleteArticles}
        />
      );
    }

    if (backbutton) {
      leftContextbuttons.unshift(backbutton);
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-primary">
            <div className="panel-heading clearfix">
              <div className="btn-group pull-left">{leftContextbuttons}</div>
              <span key="context-text" className="panel-title">
                {contextText}
              </span>
              <div className="btn-group pull-right">{rightContextButtons}</div>
            </div>
          </div>
        </div>
        <div id="media-browser-popup" />
        <div className="col-md-12">{content}</div>
      </div>
    );
  }
}

ContentManager.propTypes = {
  onChangeQueryParams: PropTypes.func.isRequired,
};

ContentManagerOverview.propTypes = {
  onChangeQueryParams: PropTypes.func.isRequired,
};

ContentManager.defaultProps = {
  availableWidgets: {
    unformattedText: {
      name: 'Neformátovaný text',
      component: ArticleWidgetText,
    },
    photo: {
      name: 'Fotografia',
      component: ArticleWidgetPhoto,
      mediaManager: true,
    },
    audio: { name: 'Audio', component: ArticleWidgetAudio, mediaManager: true },
    photogallery: {
      name: 'Fotogaléria',
      component: ArticleWidgetPhotogallery,
      mediaManager: true,
    },
    text: { name: 'Formátovaný text', component: ArticleWidgetFormattedText },
    table: { name: 'Tabuľka', component: ArticleWidgetTable },
    youtube: { name: 'Youtube video', component: ArticleWidgetYoutube },
    tvkosice: { name: 'TV Košice reportáž', component: ArticleWidgetTvkosice },
    imagead: { name: 'Banner', component: ImageadWidget },
    screenimage: {
      name: 'Panoramatický hlavný obrázok',
      component: ArticleWidgetScreenimage,
    },
    fbVideo: { name: 'Facebook video', component: ArticleFBVideoWidget },
    instagramPost: {name: 'Instagram príspevok', component: ArticleInstagramPostWidget},
    twitterPost: {name: 'Twitter príspevok', component: ArticleTwitterPostWidget},
    video: {name: 'Vlastné video', component: VideoWidget},
    soundcloud: {name: 'Soundcloud obsah', component: ArticleSoundcloudWidget}
  },
};

export default ContentManager;



// WEBPACK FOOTER //
// ./src/js/app/cm/ContentManager.jsx